<template>

          <v-dialog
            v-model="show"
            hide-overlay
            persistent
            width="300"
          >
            <v-card
              color="success"
              dark
            >
              <v-card-text>
                {{ text }}
                <v-progress-linear
                  :value="progress"
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

</template>

<script>

export default {
  name: 'LoadingDialog',
  components: {
  },
  props: ['progress', 'text', 'show'],
  data () {
    return {
    }
  },
  mounted: function () {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
